export function toLocalTime(utcDate: Date) {
  const localDate = new Date(
    utcDate.getTime() - utcDate.getTimezoneOffset() * 60000
  );
  const day = ('0' + localDate.getDate()).slice(-2);
  const month = ('0' + (localDate.getMonth() + 1)).slice(-2);
  const year = localDate.getFullYear();

  let hours = localDate.getHours();
  const minutes = ('0' + localDate.getMinutes()).slice(-2);
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12;
  const strHours = ('0' + hours).slice(-2);

  return `${month}/${day}/${year} ${strHours}:${minutes} ${ampm}`;
}

function isDateFormatted(value: string): boolean {
  const regex = /^\d{1,2}\/\d{1,2}\/\d{4} \d{1,2}:\d{2}:\d{2} (AM|PM)$/;
  return regex.test(value);
}

function isUnformatted(value: string): boolean {
  const regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
  return regex.test(value);
}

export function isDateFormat(value: any): boolean {
  if (typeof value !== 'string') {
    return false;
  }
  return isDateFormatted(value) || isUnformatted(value);
}

export function convertToDate(value: string): string | null {
  if (isDateFormat(value)) {
    return toLocalTime(new Date(value));
  } else {
    return null;
  }
}

export function convertToUTC(dateString?: string, setEndOfDay: boolean = false): string | undefined {
  if (!dateString) {
    return undefined;
  }

  const date = new Date(dateString);
  if (setEndOfDay) {
    date.setUTCHours(23, 59, 59, 999);
  }

  return date.toISOString();
}